import { Dialog } from "@radix-ui/react-dialog";
import { useState } from "react";
import { DialogBody, DialogContent, DialogHeader, DialogTitle } from "./Dialog";
import { Button } from "./Button";

export interface InformationDialogProps {
  title?: string;
  message?: React.ReactNode;
  onSubmit?: () => Promise<void>;
  onConfirm?: () => void;
  confirmLabel?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const InformationDialog = ({
  title = "Information",
  message,
  onSubmit,
  onConfirm,
  confirmLabel = "OK",
  open,
  setOpen,
}: InformationDialogProps) => {
  const [loading, setLoading] = useState(false);

  if (typeof message === "string") {
    message = <p>{message}</p>;
  }

  const onClickHandler = async () => {
    if (onSubmit) {
      setLoading(true);
      await onSubmit();
      setLoading(false);
    }
    onConfirm?.();
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="my-2">{message}</div>
          <div className="flex flex-row justify-end mt-2">
            <Button disabled={loading} onClick={onClickHandler}>
              {confirmLabel}
            </Button>
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
